import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './pagination.scss.js';
import css_248z$1 from './pagination-cvt.scss.js';

class PaginationNav extends s {
    constructor() {
        super(...arguments);
        this.numberOfPages = 1;
        this._templateStyle = 'classic';
        this.currentPage = 1;
    }
    get templateStyle() {
        return this._templateStyle;
    }
    set templateStyle(value) {
        if (this._templateStyle !== value) {
            this._templateStyle = value;
            this.requestUpdate();
        }
    }
    static createEllipsis(position) {
        return $ `<li class="${position}"></li>`;
    }
    addPreviousButton(pages, current) {
        if (current > 1) {
            pages.push(this.createNavLink('previous', current - 1, 'Go to Previous Page'));
        }
    }
    addNextButton(pages, current, total) {
        if (current < total) {
            pages.push(this.createNavLink('next', current + 1, 'Go to Next Page'));
        }
    }
    addAllPages(pages, total, current) {
        for (let i = 1; i <= total; i += 1) {
            pages.push(this.createPageLink(i, current, i === 1 ? 'first' : 'page'));
        }
    }
    addStartPages(pages, current) {
        if (current > 2) {
            pages.push(this.createPageLink(1, current, 'first'));
            if (current > 3) {
                pages.push(PaginationNav.createEllipsis('start'));
            }
        }
    }
    addMiddlePages(pages, current, total) {
        if (current - 1 > 1) {
            pages.push(this.createPageLink(current - 1, current));
        }
        pages.push(this.createPageLink(current, current));
        if (current + 1 < total) {
            pages.push(this.createPageLink(current + 1, current));
        }
    }
    addEndPages(pages, current, total) {
        if (current < total - 1) {
            if (current < total - 2) {
                pages.push(PaginationNav.createEllipsis('end'));
            }
            pages.push(this.createPageLink(total, current));
        }
    }
    goToPage(page, e) {
        if (e)
            e.preventDefault();
        if (page < 1 || page > this.numberOfPages || page === this.currentPage)
            return;
        this.currentPage = page;
        this.dispatchEvent(new CustomEvent('page-changed', {
            detail: { page },
            bubbles: true,
            composed: true,
        }));
    }
    createNavLink(type, value, label) {
        return $ `<li class="${type}"><a href="#" title="${label}" aria-label="${label}" @click="${(e) => this.goToPage(value, e)}"><span class="arrow-text">${label}</span></a></li>`;
    }
    createPageLink(value, current, extraClass = 'page') {
        return $ `<li class="${extraClass}"><a href="#" title="Go to Page ${value}" aria-label="Go to Page ${value}" class="${value === current ? 'active' : ''}" @click="${(e) => this.goToPage(value, e)}">${value}</a></li>`;
    }
    generatePagination() {
        const total = this.numberOfPages;
        const current = this.currentPage;
        const pages = [];
        this.addPreviousButton(pages, current);
        if (total <= 4) {
            this.addAllPages(pages, total, current);
        }
        else {
            this.addStartPages(pages, current);
            this.addMiddlePages(pages, current, total);
            this.addEndPages(pages, current, total);
        }
        this.addNextButton(pages, current, total);
        return pages;
    }
    render() {
        if (this.numberOfPages < 2) {
            return $ ``;
        }
        const navClass = this.templateStyle === 'cvt' ? 'pagination-cvt' : 'pagination';
        return $ `<div style="padding:1rem"><nav class="${navClass}"><ul>${this.generatePagination()}</ul></nav></div>`;
    }
}
PaginationNav.styles = [css_248z, css_248z$1];
__decorate([
    e({ type: Number })
], PaginationNav.prototype, "numberOfPages", void 0);
__decorate([
    e({ type: String })
], PaginationNav.prototype, "templateStyle", null);
__decorate([
    t()
], PaginationNav.prototype, "currentPage", void 0);
customElements.define('pagination-nav', PaginationNav);

export { PaginationNav };
